import {
  checkHttpStatus,
  getApiBaseUrlWithOrg,
  getApiHeadersFromToken
} from '../../../utils'

export const fetchJourneyLevels = async (
  apiData,
  activityCourseId,
  journeyId
) => {
  const url = `${getApiBaseUrlWithOrg(
    apiData.orgId
  )}/mentor/master_courses/${activityCourseId}/courses/${journeyId}/levels`
  try {
    const response = checkHttpStatus(
      await fetch(url, {
        method: 'GET',
        headers: getApiHeadersFromToken(apiData.token)
      })
    )
    return await response.json()
  } catch (error) {
    console.log(error)
  }
}

export const createNewJourneyLevel = async (
  apiData,
  activityCourseId,
  journeyId,
  levelName,
  levelDescription,
  levelMastery
) => {
  const url = `${getApiBaseUrlWithOrg(
    apiData.orgId
  )}/mentor/master_courses/${activityCourseId}/courses/${journeyId}/levels`
  const data = {
    level: {
      name: levelName,
      description: levelDescription,
      mastery: levelMastery
    }
  }
  try {
    const response = checkHttpStatus(
      await fetch(url, {
        method: 'POST',
        headers: getApiHeadersFromToken(apiData.token),
        body: JSON.stringify(data)
      })
    )
    return await response.json()
  } catch (error) {
    console.log(error)
  }
}

export const deleteJourneyLevel = async (
  apiData,
  activityCourseId,
  journeyId,
  levelId
) => {
  const url = `${getApiBaseUrlWithOrg(
    apiData.orgId
  )}/mentor/master_courses/${activityCourseId}/courses/${journeyId}/levels/${levelId}`

  try {
    checkHttpStatus(
      await fetch(url, {
        method: 'DELETE',
        headers: getApiHeadersFromToken(apiData.token)
      })
    )
  } catch (error) {
    console.log(error)
  }
}

export const editJourneyLevel = async (
  apiData,
  activityCourseId,
  journeyId,
  levelId,
  levelName,
  levelDescription,
  levelMastery
) => {
  const url = `${getApiBaseUrlWithOrg(
    apiData.orgId
  )}/mentor/master_courses/${activityCourseId}/courses/${journeyId}/levels/${levelId}`

  try {
    const response = checkHttpStatus(
      await fetch(url, {
        method: 'PATCH',
        headers: getApiHeadersFromToken(apiData.token),
        body: JSON.stringify({
          level: {
            name: levelName,
            description: levelDescription,
            mastery: levelMastery
          }
        })
      })
    )
    return await response.json()
  } catch (error) {
    console.log(error)
  }
}

export const fetchJourneyLevel = async (
  apiData,
  activityCourseId,
  journeyId,
  levelId
) => {
  const url = `${getApiBaseUrlWithOrg(
    apiData.orgId
  )}/mentor/master_courses/${activityCourseId}/courses/${journeyId}/levels/${levelId}`
  try {
    const response = checkHttpStatus(
      await fetch(url, {
        method: 'GET',
        headers: getApiHeadersFromToken(apiData.token)
      })
    )
    return await response.json()
  } catch (error) {
    console.log(error)
  }
}

export const reorderJourneyLevels = async (
  apiData,
  activityCourseId,
  journeyId,
  levels
) => {
  const url = `${getApiBaseUrlWithOrg(
    apiData.orgId
  )}/mentor/master_courses/${activityCourseId}/courses/${journeyId}/reorder_levels`

  try {
    const response = checkHttpStatus(
      await fetch(url, {
        method: 'PATCH',
        headers: getApiHeadersFromToken(apiData.token),
        body: JSON.stringify({
          course: {
            levels_order: levels
          }
        })
      })
    )

    return await response.json()
  } catch (err) {
    console.log('ERROR', err)
  }
}



// WEBPACK FOOTER //
// ./src/components/mycourses/Levels/API.js